import parseHTML, { Element, domToReact } from "html-react-parser";

export function html2react(htmlString: string, whitelist: string[] = []) {
  whitelist = whitelist.map((s) => s.toLowerCase());
  const replace = (node: any) => {
    if (node instanceof Element) {
      if (!whitelist.includes(node.tagName.toLowerCase())) {
        return <>{domToReact(node.children, { replace })}</>;
      }
    }
  };
  return parseHTML(htmlString, {
    replace,
  });
}
